// frontend/src/components/AIButton.jsx
import React, { useEffect, useState, useContext } from "react";
import { AIContext } from "../context/AIContext";
import "./AIButton.css";

export default function AIButton() {
  const [visible, setVisible] = useState(false);
  const { isAIOpen, setIsAIOpen } = useContext(AIContext);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(true);
      window.removeEventListener("scroll", handleScroll);
    };

    const timer = setTimeout(() => {
      setVisible(true);
      window.addEventListener("scroll", handleScroll);
    }, 4000);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleClick = () => {
    setIsAIOpen(true);
    setVisible(false);
  };

  return visible && !isAIOpen ? (
    <button className="ai-popup-button" onClick={handleClick}>
      🤖 AI Guide
    </button>
  ) : null;
}